module.exports = __webpack_public_path__ + "static/media/LOGO_INARI.75e28557.png";